import { render } from "./salvationPrayers.vue?vue&type=template&id=db21bb88&scoped=true"
import script from "./salvationPrayers.vue?vue&type=script&lang=js"
export * from "./salvationPrayers.vue?vue&type=script&lang=js"

import "./salvationPrayers.vue?vue&type=style&index=0&id=db21bb88&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db21bb88"]])

export default __exports__